var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopWatch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8739 1.68789L11.1449 0.468068C11.1701 0.354259 11.1423 0.235219 11.0694 0.143915C10.9962 0.0530056 10.8861 0 10.7693 0H7.69233C7.57556 0 7.4655 0.0530056 7.39226 0.143816C7.31942 0.23512 7.29158 0.354161 7.31675 0.46797L7.5878 1.68789C3.27954 2.4655 0 6.24045 0 10.7692C0 15.859 4.14105 20 9.23078 20C14.3205 20 18.4616 15.8589 18.4616 10.7692C18.4617 6.24045 15.1821 2.4655 10.8739 1.68789ZM10.29 0.769223L10.1191 1.53845H8.34251L8.17165 0.769223H10.29ZM9.23078 19.2309C4.565 19.2309 0.769223 15.4351 0.769223 10.7693C0.769223 6.10354 4.565 2.30777 9.23078 2.30777C13.8966 2.30777 17.6923 6.10354 17.6923 10.7693C17.6923 15.4351 13.8966 19.2309 9.23078 19.2309Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3858 10.7668C10.3858 10.266 10.0633 9.84306 9.61657 9.68375V3.84375H8.84735V9.68385C8.4006 9.84316 8.07812 10.2661 8.07812 10.7669C8.07812 11.4031 8.59574 11.9207 9.23201 11.9207C9.28936 11.9207 9.34434 11.912 9.39951 11.9039L11.8176 15.531L12.4577 15.1043L10.0819 11.5407C10.2688 11.3355 10.3858 11.0655 10.3858 10.7668ZM9.23191 11.1514C9.01969 11.1514 8.84735 10.9791 8.84735 10.7668C8.84735 10.5545 9.01969 10.3821 9.23201 10.3821C9.44423 10.3821 9.61667 10.5544 9.61667 10.7668C9.61667 10.9791 9.44413 11.1514 9.23191 11.1514Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopWatch);
export default __webpack_public_path__ + "static/media/stopWatch.fa0fc3833c255520a7e0cd7a15ba8d61.svg";
export { ForwardRef as ReactComponent };